export default __webpack_public_path__ + "images/0a11aa7c11ef45e975a9b918d4791a3c.png";